export default {
  /** 原料进出存-获取分页查询列表 */
  LIST_MATERIALSINANDOUTSTORE_BY_PAGE: '/produce/materialsInoutbound/queryPage',
  /** 原料进出存-导出列表 */
  LIST_MATERIALSINANDOUTSTORE_EXPORT: '/produce/materialsInoutbound/exportExcel',
};
